import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row } from 'reactstrap';

import moment from 'moment-es6';

import { getEntity } from '../../../services/entity/entity-service';

import LoadingSpinner from '../../components/loading-spinner/loading-spinner';
import DateRangePicker from '../../components/date-range-picker/date-range-picker';
import FormSection from '../../components/form-section/form-section';
import Input from '../../components/input/input';
import MultiSelect from '../../components/multiselect/multiselect';
import PlayerDashboardButtons from '../../components/player-dashboard-buttons/player-dashboard-buttons';
import Result from '../../components/results/result';

import { getPlayer } from '../../../modules/player';
import { resultsActions } from '../../../modules/views/result_view';
import { getResultsView } from '../../../modules/views/result_view_api';

import './player-activities.css';
import { weeks } from '../../../services/date/date-service';
import { getPositions } from '../../../modules/system/position';
import { getSkills } from '../../../modules/system/skill';
import { withWhiteLabelContext } from 'react-whitelabel';

class PlayerActivities extends Component {
  constructor(props) {
    super(props);

    const previousWeek = weeks(1);

    this.state = {
      player: {},

      filterStartDate: moment(previousWeek[0][6].toString()),
      filterStopDate: moment(previousWeek[0][0].toString()),
      filterName: '',
      filterOptions: {},
    };

    this.initiateResultFetch = this.initiateResultFetch.bind(this);
    this.setPlayer = this.setPlayer.bind(this);
  }

  componentDidMount() {
    const { label } = this.props;
    this.props.resetState();

    this.props.dispatch(getSkills());
    this.props.dispatch(getPositions([{ platform_id: `${label.platform.platform_id}` }]));

    if (this.props.match.params.id && parseInt(this.props.match.params.id, 10) !== this.state.player.id) {
      this.setPlayer(this.props.match.params.id);
    }
  }

  async setPlayer(playerId) {
    const player = await getEntity(this.props.dispatch, getPlayer(playerId));
    this.setState({ player });
  }

  componentDidUpdate() {
    if (this.props.should_get_results && !this.props.getting_results) {
      const currentPlayerID = this.props.match.params.id;
      if (currentPlayerID) {
        this.props.getResults(currentPlayerID, this.props.page);
        this.props.startGettingResults();
      }
    }
  }

  initiateResultFetch() {
    this.props.shouldGetResults(true);
  }

  render() {
    return (
      <div className="px-1">
        <FormSection component={this.playerActivities()} />
      </div>
    );
  }

  playerActivities = () => {
    const { results } = this.props;
    const { filterName, filterStartDate, filterStopDate, filterOptions } = this.state;

    const filteredResults =
      results &&
      results.filter((result) => {
        const createdDate = new Date(result.created);
        const _filterStopDate = filterStopDate && new Date(filterStopDate.valueOf());
        _filterStopDate && _filterStopDate.setDate(_filterStopDate.getDate() + 1);

        if (filterStartDate && createdDate < filterStartDate) {
          return false;
        }
        if (_filterStopDate && createdDate >= _filterStopDate) {
          return false;
        }
        if (filterName && !result.session_name.toLowerCase().includes(filterName.toLowerCase())) {
          return false;
        }

        let isFiltered = !filterOptions.length > 0;
        filterOptions.length > 0 &&
          filterOptions.forEach((filter) => {
            if (result[filter.key] === filter.value) {
              isFiltered = true;
            }
          });

        if (!isFiltered) {
          return false;
        }

        return result;
      });

    const filterComponent = (
      <Row className="ml-0 mr-3 my-0 p-0">
        <p className="mr-1 my-auto p-0 very-small secondary-color">Filters:</p>
        <div className="mx-1 my-0 p-0">
          <Input
            style={{ fontSize: 12 }}
            className="py-1"
            formgroupclassname="mp-0"
            placeholder="Session Name"
            onChange={(filterName) => {
              this.setState({ filterName });
            }}
          />
        </div>
        <DateRangePicker
          small
          initialStartDate={this.state.filterStartDate}
          initialEndDate={this.state.filterStopDate}
          _onDatesChange={(filterStartDate, filterStopDate) => {
            this.setState({ filterStartDate, filterStopDate });
          }}
        />
      </Row>
    );

    return (
      <div className="mp-0 container-fluid">
        <PlayerDashboardButtons
          player={this.state.player}
          activePage="activities"
          isTherapistRole={this.props.isTherapistRole}
        />
        <FormSection
          sectionLabel="Activity Results"
          headerComponent={filterComponent}
          component={this.activitiesComponent(filteredResults)}
        />
      </div>
    );
  };

  buildTags = () => {
    const { skills, positions } = this.props;

    const tags = [];
    tags.push({ label: 'Skill', disabled: true, value: 'skill-' });

    tags.concat(
      skills &&
        skills.map((skill) => {
          return { label: skill.name, value: `skill-${skill.name}` };
        })
    );

    tags.push({ label: 'Position', disabled: true, value: 'position-' });

    tags.concat(
      positions &&
        positions.map((position) => {
          return { label: position.name, value: `position-${position.name}` };
        })
    );
    return tags;
  };

  activitiesComponent = (filteredResults) => {
    const { player_id, user } = this.props;
    const tags = this.buildTags();

    return (
      <div className="mp-0">
        <Row className="m-1 p-0 small">
          <MultiSelect
            style={{ minWidth: 150 }}
            options={tags}
            placeholder="tags"
            _onChange={(inputValue) => {
              if (inputValue === '') {
                this.setState({ filterOptions: {} });
                return;
              }

              const filterOptions = inputValue.split(',').map((val) => {
                const splitValue = val.split('-');
                return { key: splitValue[0], value: splitValue[1] };
              });

              this.setState({ filterOptions });
            }}
          />
        </Row>
        <Row className="mp-0">
          {this.props.loaded &&
            filteredResults.map((result) => (
              <div className="mx-2 p-0">
                <Result key={result.id} result={result} player_id={player_id} current_user={user} />
              </div>
            ))}
        </Row>

        {!this.props.loaded && <LoadingSpinner />}
        {this.props.getting_results && !this.props.done && (
          <div className="results_loading_message">
            Loading Results <i className="fa fa-spinner fa-spin"></i>
          </div>
        )}
        {!this.props.getting_results && !this.props.done && !this.props.should_get_results && (
          <Row className="mp-0">
            <button
              id="load_more_results"
              onClick={() => {
                this.initiateResultFetch();
              }}
            >
              Load More
            </button>
          </Row>
        )}
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    results: state.result_view.results,
    player_id: state.player.player.id,
    should_get_results: state.result_view.should_get_results,
    getting_results: state.result_view.getting_results,
    page: state.result_view.page,
    done: state.result_view.done,
    loaded: state.result_view.loaded,
    user: state.user,
  };
};

const mapDispatchToProps = {
  resetState: resultsActions.resetState,
  getResults: getResultsView,
  startGettingResults: resultsActions.startGettingResults,
  shouldGetResults: resultsActions.shouldGetResults,
};

const withState = connect((state) => {
  const { position, skill, user } = state;

  return {
    positions: position.positions,
    skills: skill.skills,
    isTherapistRole: user.isTherapistRole,
  };
});

const ResultsDashboardContainer = withWhiteLabelContext(
  withRouter(withState(connect(mapStateToProps, mapDispatchToProps)(PlayerActivities)))
);

export default ResultsDashboardContainer;
